export default "__VITE_ASSET__BKkp9RWR__"